"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileService = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var index_1 = require("./index");
var UserProfileService = /** @class */ (function () {
    function UserProfileService(log) {
        this.log = log;
        this.__priority = 100;
    }
    UserProfileService.prototype.init = function () {
        var _this = this;
        this.userProfileFetchable = new core_shared_1.IkeFetchableMany(this.log, core_shared_1.IkeRest.createStore(), this.fetchUserProfiles);
        (0, mobx_1.reaction)(function () { return index_1.Services.Department.current; }, function () {
            if (!index_1.Services.Route.profilesLoaded) {
                _this.userProfileFetchable.fetch().then(function () {
                    index_1.Services.Route.profilesLoaded = true;
                });
            }
            _this.userProfileFetchable.reset();
        });
    };
    Object.defineProperty(UserProfileService.prototype, "list", {
        get: function () {
            return this.userProfileFetchable.value;
        },
        enumerable: false,
        configurable: true
    });
    UserProfileService.prototype.get = function (userId) {
        return this.userProfileFetchable.find('objectId', userId);
    };
    UserProfileService.prototype.refresh = function () {
        this.userProfileFetchable.refetch();
    };
    UserProfileService.prototype.isDepartmentAdmin = function (userProfile) {
        return userProfile != null && userProfile.role === core_api_1.IkeUserRole.ROOT;
    };
    UserProfileService.prototype.isDepartmentEditor = function (userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.EDITOR;
    };
    UserProfileService.prototype.isDepartmentViewer = function (userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.VIEWER;
    };
    UserProfileService.prototype.isDepartmentDownloader = function (userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.DOWNLOADER;
    };
    UserProfileService.prototype.isDepartmentDataAdmin = function (userProfile) {
        return userProfile != null && userProfile.userLevel === core_api_1.IkeUserRole.DATA_ADMIN;
    };
    UserProfileService.prototype.isOneOf = function (userProfile, userRoles) {
        for (var _i = 0, userRoles_1 = userRoles; _i < userRoles_1.length; _i++) {
            var userRole = userRoles_1[_i];
            if (userProfile != null && (userProfile.userLevel === userRole)) {
                return true;
            }
        }
        return false;
    };
    UserProfileService.prototype.isReadOnly = function (userProfile) {
        return this.isOneOf(userProfile, [core_api_1.IkeUserRole.VIEWER, core_api_1.IkeUserRole.DOWNLOADER]);
    };
    UserProfileService.prototype.canExportReports = function (userProfile) {
        if (this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    };
    UserProfileService.prototype.canImportCollections = function (userProfile) {
        if (this.isDepartmentDownloader(userProfile) ||
            this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    };
    UserProfileService.prototype.canEditForms = function (userProfile) {
        if (this.isDepartmentDownloader(userProfile) ||
            this.isDepartmentViewer(userProfile) ||
            this.isDepartmentEditor(userProfile)) {
            return false;
        }
        return true;
    };
    UserProfileService.prototype.fetchUserProfiles = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, rest, departmentUsers, userProfiles, userProfileMap, _i, userProfiles_1, userProfile, i, userProfile;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        rest = index_1.Services.Department.rest;
                        if (!rest) return [3 /*break*/, 3];
                        return [4 /*yield*/, rest.Department.User.list(null)];
                    case 1:
                        departmentUsers = (_a.sent()).results;
                        return [4 /*yield*/, rest.query(rest.Objects.UserProfile)
                                .in('objectId', departmentUsers.map(function (depUsr) { return depUsr.userId; }))
                                .find()];
                    case 2:
                        userProfiles = _a.sent();
                        userProfileMap = {};
                        for (_i = 0, userProfiles_1 = userProfiles; _i < userProfiles_1.length; _i++) {
                            userProfile = userProfiles_1[_i];
                            userProfileMap[userProfile.objectId] = userProfile;
                        }
                        for (i = 0; i < departmentUsers.length; i++) {
                            userProfile = userProfileMap[departmentUsers[i].userId];
                            if (userProfile == null) {
                                continue;
                            }
                            result.push(tslib_1.__assign({ role: departmentUsers[i].role, userLevel: departmentUsers[i].userLevel }, userProfile));
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, result];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], UserProfileService.prototype, "list", null);
    return UserProfileService;
}());
exports.UserProfileService = UserProfileService;
//# sourceMappingURL=user.profile.service.js.map